import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="shadowroot" id="shadowroot"></a>
    <h1 {...{
      "id": "windowshadowroot"
    }}>{`window.ShadowRoot`}</h1>
    <p>{`[ This feature is behind a feature flag. You must turn on `}<inlineCode parentName="p">{`enableSWCSupport`}</inlineCode>{` in the featureFlags section of plugin manifest to use the same ]`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot"
      }}>{`Web APIs - ShadowRoot`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.0.0  `}</p>
    <a name="shadowroot-mode" id="shadowroot-mode"></a>
    <h2 {...{
      "id": "mode--element"
    }}>{`mode : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns the mode of the ShadowRoot — either open or closed. This defines whether or not the shadow root's internal features are accessible from JavaScript.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/mode"
      }}>{`ShadowRoot - mode`}</a>{`  `}</p>
    <a name="shadowroot-host" id="shadowroot-host"></a>
    <h2 {...{
      "id": "host--element"
    }}>{`host : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns a reference to the DOM element the ShadowRoot is attached to.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/host"
      }}>{`ShadowRoot - host`}</a>{`  `}</p>
    <a name="shadowroot-innerhtml" id="shadowroot-innerhtml"></a>
    <h2 {...{
      "id": "innerhtml--string"
    }}>{`innerHTML : `}<inlineCode parentName="h2">{`string`}</inlineCode></h2>
    <p>{`Returns a reference to the DOM tree inside the ShadowRoot`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/innerHTML"
      }}>{`ShadowRoot - innerHTML`}</a>{`  `}</p>
    <a name="shadowroot-activeelement" id="shadowroot-activeelement"></a>
    <h2 {...{
      "id": "activeelement--element"
    }}>{`activeElement : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Returns the element within the shadow tree that has focus`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ShadowRoot/activeElement"
      }}>{`ShadowRoot - activeElement`}</a>{`  `}</p>
    <a name="shadowroot-clonenode" id="shadowroot-clonenode"></a>
    <h2 {...{
      "id": "clonenodedeep"
    }}>{`cloneNode(deep)`}</h2>
    <p>{`Duplicate of the node on which this method was called. Its parameter controls if the subtree contained in a node is also cloned or not`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/Node/cloneNode"
      }}>{`ShadowRoot - cloneNode`}</a>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`deep`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional param to clone whole sub tree(True) or only node (False)`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      